/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyJobMappingReplacementAutoMatchingType {
    EXISTING_JOB_MAPPING = 'existingJobMapping',
    YEAR_OVER_YEAR = 'yearOverYear',
    JOB_CODE = 'jobCode',
    TARGET_ONLY = 'targetOnly',
}
